<template>
    <div id="navigation">
        <ul>
            <li>
                <router-link to="/">Home</router-link>
            </li>
            <li id="about">
                <router-link to="/About">About</router-link>
            </li>
        </ul>
    </div>
</template>

<style scoped>
    #navigation ul{
        list-style-type: none;
        margin: 0;
        padding: 0;
        overflow: hidden;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 100;
    }
    #navigation li{
        float: left;
    }
    #navigation li a:hover:not(.active){
        background-color: #eddbb2;
        color: black;
    }
    #navigation a{
        opacity: 1;
        text-decoration: none;
        padding: 6px 6px 6px 6px;
        font-size: 32px;
        display: block;
        transition: 0.3s;
        color: #eddbb2;
        background-color: #282828;
    }
</style>